import React from 'react';
import classnames from 'classnames';

import { ModalRawHTML } from '../../RawHTML/ModalRawHTML';
import { ReviewsIoComponentFragment } from '../../../../graphql.schema';

import * as styles from './StrapiReviewsIOComponent.module.scss';

type StrapiReviewIOComponentPropType = ReviewsIoComponentFragment & {
  hasRTL?: boolean;
  loadDefer?: boolean;
};
export const StrapiReviewsIOComponent: React.FC<StrapiReviewIOComponentPropType> = ({
  heading,
  script,
  hasRTL = false,
  loadDefer
}) => {

  return (
    <div className={classnames(hasRTL ? 'mt-5' : '', styles.root)}>
      <h2 className={classnames('title is-2 has-text-centered', styles.title)}>{heading}</h2>
      <ModalRawHTML className={styles.carouselWidget} html={script?.htmlCode} loadDefer={loadDefer} />
    </div>
  );
};
